import { IStudentRow, ITab } from 'api-paths-cas';

export enum DashboardActionTypes {
  SWITCH_TAB = '@@dashboard/switch_tab',
  GET_STUDENTS = '@@dashboard/get_students',
  GET_TOTALS = '@@dashboard/get_totals',
  GET_TOTALS_FAILURE = '@@dashboard/get_totals_failure',
  GET_APPLICATIONS = '@@dashboard/get_applications',
  CLEAR_STUDENTS = '@@dashboard/clear_students',
  GET_STUDENTS_SUCCESS = '@@dashboard/get_students_success',
  GET_TOTALS_SUCCESS = '@@dashboard/get_totals_success',
  GET_FILTERS = '@@dashboard/get_filters',
  GET_FILTERS_SUCCESS = '@@dashboard/get_filters_success',
  GET_FILTERS_FAILURE = '@@dashboard/get_filters_failure',
  ADD_MORE_STUDENTS_SUCCESS = '@@dashboard/add_more_students_success',
  GET_STUDENTS_COMPLETE = '@@dashboard/get_students_complete',
  GET_STUDENTS_FAILURE = '@@dashboard/get_students_failure',
  UPDATE_STUDENT = '@@dashboard/update_student',
  UPDATE_STUDENT_CURRENTLY_OPENED = '@@dashboard/update_student_currently_opened',
  STUDENT_OPENED_RECEIVED = '@@dashboard/student_opened_received',
  STUDENT_CLOSED_RECEIVED = '@@dashboard/student_closed_received',
  OPEN_STUDENT_RECORDS = '@@dashboard/open_student_records',
  STUDENT_STATUS_CHANGE = '@@dashboard/student_status_change',
  MULTI_TRANSITION_STATUS = '@@dashboard/multi_transition_status',
  MULTI_TRANSITION_STATUS_SUCCESS = '@@dashboard/multi_transition_status_success',
  MULTI_TRANSITION_STATUS_FAILURE = '@@dashboard/multi_transition_status_failure',
  SET_FILTERS = '@@dashboard/set_filters',
  SET_SORT = '@@dashboard/set_sort',
  SET_FILTERS_VISIBLE = '@@dashboard/set_filters_visible',
  SET_SELECTED_ROWS = '@@dashboard/set_selected_rows',
  SET_IS_TASKBAR_OPEN = '@@dashboard/set_taskbar_open',
  SET_IS_DROPDOWN_DISABLED = '@@dashboard/set_is_dropdown_disabled',
  SET_TABS = '@@dashboard/set_tabs',

  STUDENTS_TAGS_PIN = '@@dashboard/students_tags_pin',
  BULK_ACTION = '@@dashboard/bulk_action',
  BULK_ACTION_SUCCESS = '@@dashboard/bulk_action_success',
  BULK_ACTION_FAILURE = '@@dashboard/bulk_action_failure',
  STUDENTS_TAGS_PIN_SUCCESS = '@@dashboard/students_tags_pin_success',
  STUDENTS_TAGS_PIN_FAILURE = '@@dashboard/students_tags_pin_failure',

  STUDENTS_TAGS_UNPIN = '@@dashboard/students_tags_unpin',
  STUDENTS_TAGS_UNPIN_SUCCESS = '@@dashboard/students_tags_unpin_success',
  STUDENTS_TAGS_UNPIN_FAILURE = '@@dashboard/students_tags_failure',

  STUDENTS_SERVICES_ADD = '@@dashboard/students_services_add',
  STUDENTS_SERVICES_ADD_SUCCESS = '@@dashboard/students_services_add_success',
  STUDENTS_SERVICES_ADD_FAILURE = '@@dashboard/students_services_add_failure',

  STUDENTS_SERVICES_REMOVE = '@@dashboard/students_services_remove',
  STUDENTS_SERVICES_REMOVE_SUCCESS = '@@dashboard/students_services_remove_success',
  STUDENTS_SERVICES_REMOVE_FAILURE = '@@dashboard/students_services_remove_failure',

  STUDENTS_IMMIGRATION_PROVIDER_ADD = '@@dashboard/students_immigration_provider_add',
  STUDENTS_IMMIGRATION_PROVIDER_ADD_SUCCESS = '@@dashboard/students_immigration_provider_add_success',
  STUDENTS_IMMIGRATION_PROVIDER_ADD_FAILURE = '@@dashboard/students_immigration_provider_add_failure',

  STUDENTS_IMMIGRATION_PROVIDER_REMOVE = '@@dashboard/students_immigration_provider_remove',
  STUDENTS_IMMIGRATION_PROVIDER_REMOVE_SUCCESS = '@@dashboard/students_immigration_provider_remove_success',
  STUDENTS_IMMIGRATION_PROVIDER_REMOVE_FAILURE = '@@dashboard/students_immigration_provider_remove_failure',

  STUDENT_ASSIGN_VISA_SUPPORT = '@@dashboard/student_assign_visa_support',
  STUDENT_ASSIGN_VISA_SUPPORT_SUCCESS = '@@dashboard/student_assign_visa_support_success',
  STUDENT_ASSIGN_VISA_SUPPORT_FAILURE = '@@dashboard/student_assign_visa_support_failure',

  STUDENT_UNASSIGN_VISA_SUPPORT = '@@dashboard/student_unassign_visa_support',
  STUDENT_UNASSIGN_VISA_SUPPORT_SUCCESS = '@@dashboard/student_unassign_visa_support_success',
  STUDENT_UNASSIGN_VISA_SUPPORT_FAILURE = '@@dashboard/student_unassign_visa_support_failure',

  REQUEST_SCHEDULED_INTERVIEW = '@@dashboard/request_scheduled_interview',
  REQUEST_SCHEDULED_INTERVIEW_SUCCESS = '@@dashboard/request_scheduled_interview_success',
  REQUEST_SCHEDULED_INTERVIEW_FAILURE = '@@dashboard/request_scheduled_interview_failure',

  CANCEL_SCHEDULED_INTERVIEW = '@@dashboard/cancel_scheduled_interview',
  CANCEL_SCHEDULED_INTERVIEW_SUCCESS = '@@dashboard/cancel_scheduled_interview_success',
  CANCEL_SCHEDULED_INTERVIEW_FAILURE = '@@dashboard/cancel_scheduled_interview_failure',

  CANCEL_SCHEDULED_INTERVIEW_BULK = '@@dashboard/cancel_scheduled_interview_bulk',
  CANCEL_SCHEDULED_INTERVIEW_BULK_SUCCESS = '@@dashboard/cancel_scheduled_interview_bulk_success',
  CANCEL_SCHEDULED_INTERVIEW_BULK_FAILURE = '@@dashboard/cancel_scheduled_interview_bulk_failure',

  CANCEL_RECORDED_INTERVIEW = '@@dashboard/cancel_recorded_interview',
  CANCEL_RECORDED_INTERVIEW_SUCCESS = '@@dashboard/cancel_recorded_interview_success',
  CANCEL_RECORDED_INTERVIEW_FAILURE = '@@dashboard/cancel_recorded_interview_failure',

  CANCEL_RECORDED_INTERVIEW_BULK = '@@dashboard/cancel_recorded_interview_bulk',
  CANCEL_RECORDED_INTERVIEW_BULK_SUCCESS = '@@dashboard/cancel_recorded_interview_bulk_success',
  CANCEL_RECORDED_INTERVIEW_BULK_FAILURE = '@@dashboard/cancel_recorded_interview_bulk_failure',

  REQUEST_RECORDED_INTERVIEW_BULK = '@@student/offer/REQUEST_RECORDED_INTERVIEW_BULK',
  REQUEST_RECORDED_INTERVIEW_BULK_SUCCESS = '@@student/offer/REQUEST_RECORDED_INTERVIEW_BULK_SUCCESS',
  REQUEST_RECORDED_INTERVIEW_BULK_FAILURE = '@@student/offer/REQUEST_RECORDED_INTERVIEW_BULK_FAILURE',
  SELECT_ALL = '@@dashboard/select_all',
  OPENED_STUDENT_RECORDS = '@@dashboard/OPENED_STUDENT_RECORDS',
  CLEAR_OPENED_RECORDS = '@@dashboard/CLEAR_OPENED_RECORDS',

  GET_SELECTED_PARTNERS = '@@dashboard/get_selected_partners',
  GET_SELECTED_PARTNERS_SUCCESS = '@@dashboard/get_selected_partners_success',
  GET_SELECTED_PARTNERS_COMPLETE = '@@dashboard/get_selected_partners_complete',
  GET_SELECTED_PARTNERS_FAILURE = '@@dashboard/get_selected_partners_failure',

  GET_SELECTED_TAGS = '@@dashboard/get_selected_tags',
  GET_SELECTED_TAGS_SUCCESS = '@@dashboard/get_selected_tags_success',
  GET_SELECTED_TAGS_COMPLETE = '@@dashboard/get_selected_tags_complete',
  GET_SELECTED_TAGS_FAILURE = '@@dashboard/get_selected_tags_failure',

  STUDENT_OPENED = '@@dashboard/student_opened',
  STUDENT_CLOSED = '@@dashboard/student_closed',

  HANDLE_OPENED_STUDENT_RECORDS = '@@dashboard/handle_opened_student_records',
  TRIGGER_SITS_TRANSFER = '@@dashboard/trigger_SITS_transfer',
  TRIGGER_SITS_TRANSFER_SUCCESS = '@@dashboard/trigger_SITS_transferSuccess',
  TRIGGER_SITS_TRANSFER_FAILURE = '@@dashboard/trigger_SITS_transferFailure',
}

export interface IOpenedStudentsRecord {
  studentNumber: string;
  userName: string;
  status?: string;
}

export interface IStudentsDashboardFilterOptions {
  agent?: string[];
  courses?: string[];
  immigrationProvider?: string[];
  nationality?: string[];
  partner?: string[];
  pathway?: string[];
  residency?: string[];
  applicationCountry?: string[];
  riskRegion?: string[];
  tag?: { label: string; value: string; type: string }[];
  uni?: { label: string; value: string }[];
  faculty?: { label: string; value: string }[];
}

export interface ITotal {
  casStatus: string;
  total: number;
}

export interface ISelectedOption {
  [key: string]: number;
}

export interface DashboardState {
  readonly students?: Array<IStudentRow>;
  readonly openedStudentRecords: Array<IOpenedStudentsRecord>;
  readonly resetDropdownStatus: boolean;
  readonly isDropdownDisabled: boolean;
  filters: Array<{ filterKey: string; value: string; label: string }>;
  sort?: {
    col?: string;
    direction?: string;
  };
  isFiltersVisible: boolean;
  allStudentsLoaded: boolean;
  selectedRows: string[];
  isTaskBarOpened: boolean;
  tabs: ITab[];
  totals?: ITotal[];
  filterOptionsLoading: boolean;
  filterOptions: IStudentsDashboardFilterOptions;
  allSelected: boolean;
  allStudentsSelected: boolean;
  selectedPartnersTotals: ISelectedOption;
  selectedPartnersLoading: boolean;
  selectedTagsTotals: ISelectedOption;
  selectedTagsLoaded: boolean;
  sitsTransferResponse: string | null;
}
